import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Check2Circle } from "react-bootstrap-icons";

const SavedCheck = ({ saved, savedKey }) => {
  return (
    <>
      {saved[savedKey] && (
        <Check2Circle color="#0BA909" style={{ width: "34px", height: "34px" }} />
      )}
    </>
  );
};

SavedCheck.propTypes = {
  saved: PropTypes.object.isRequired,
  savedKey: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    saved: state.basic.saved,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SavedCheck);
